import { h } from 'preact';
import { batch } from '@preact/signals';
import { useStore } from 'src/hooks';
import TermsComponent from 'src/components/terms';

const Terms = () => {
    const ctx = useStore();

    batch(() => {
        ctx.layout.title.value = 'Chathost Terms & Conditions';
        ctx.layout.subtitle.value = '';
        ctx.layout.description.value = '';
        ctx.layout.type.value = 'full';
    });

    return <TermsComponent />;
};

export default Terms;
